import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import { visuallyHidden } from '@mui/utils';
import Editstudent from '../../pages/idcard/Editstudent';
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { deleteidstudent } from '../../slices/idcard';
import html2canvas from 'html2canvas';
import { toCanvas } from 'html-to-image';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import idframe from '../../assets/images/id_frame.png';
import downloadjs from 'downloadjs';
import ImageLoaderComponent from './ImageLoader';
import { jsPDF } from "jspdf";


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}


function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, columns } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell>
        {columns.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected, divRefs, setLoader, rowsSelect, idvalue } = props;


  // const captureImagesAndDownload = async () => {
  //   const zip = new JSZip();
  //   const imagePromises = divRefs.current.map(async (div, index) => {
  //     const canvas = await toCanvas(div);
  //     const dataUrl = canvas.toDataURL('image/png');
  //     // downloadjs(dataUrl, 'download.png', 'image/png');

  //     const imgData = dataUrl.split(',')[1];
  //     zip.file(`image${index + 1}.png`, imgData, { base64: true });
  //   });

  //   await Promise.all(imagePromises);
  //   const content = await zip.generateAsync({ type: 'blob' });
  //   saveAs(content, 'id_images.zip');
  // };


  const captureImagesAndDownload = async () => {
    setLoader(true); // Start loader
    console.log("divRefs", divRefs);

    const groupSize = 2;
    const result = [];

    for (let i = 0; i < divRefs.current.length; i++) {
      const groupIndex = Math.floor(i / groupSize);
      result.push({
        id: divRefs.current[i],
        value: rowsSelect[groupIndex],
      });
    }

    console.log("result", result);

    try {
      setLoader(true); // Start loader
      const zip = new JSZip();
      const imagePromises = divRefs.current.map(async (div, index) => {
        const canvas = await toCanvas(div);
        const dataUrl = canvas.toDataURL('image/png');


         const personFolder = zip.folder(result[index].value.name);

        const imgData = dataUrl.split(',')[1];

        const imageNumber = index + 1;

         personFolder.file(
          `${idvalue}_${imageNumber % 2 === 0 ? 'back' : 'front'}.png`,
          imgData,
          { base64: true }
        );

        // zip.file(`image_${result[index].value.name}_${index + 1}.png`, imgData, { base64: true });
      });

      await Promise.all(imagePromises);
      setLoader(false); // Stop loader
      const content = await zip.generateAsync({ type: 'blob' });
      saveAs(content, 'id_images.zip');
    } catch (error) {
      console.error('Error generating images:', error);
    } finally {
      setLoader(false); // Stop loader
      // window.location.reload();
    }
  };

//   const captureImagesAndDownload = async () => {
//   setLoader(true);

//   const groupSize = 2;
//   const result = [];

//   // Prepare name mapping
//   for (let i = 0; i < divRefs.current.length; i++) {
//     const groupIndex = Math.floor(i / groupSize);
//     result.push({
//       id: divRefs.current[i],
//       value: numSelected[groupIndex],
//     });
//   }

//   try {
//     const zip = new JSZip();

//     const padding = 60; // px padding on all sides

// const pdfPromises = divRefs.current.map(async (div, index) => {
//   const canvas = await toCanvas(div);
//   const imgData = canvas.toDataURL("image/jpeg", 1.0);

//   const pdf = new jsPDF({
//     orientation: "portrait",
//     unit: "px",
//     format: "a4",
//   });

//   const pageWidth = pdf.internal.pageSize.getWidth();
//   const pageHeight = pdf.internal.pageSize.getHeight();

//   const imgWidth = canvas.width;
//   const imgHeight = canvas.height;

//   // Area available (inside padding)
//   const availableWidth = pageWidth - padding * 2;
//   const availableHeight = pageHeight - padding * 2;

//   // Scale image to fit inside the padded area
//   const scale = Math.min(availableWidth / imgWidth, availableHeight / imgHeight);

//   const finalWidth = imgWidth * scale;
//   const finalHeight = imgHeight * scale;

//   // Center inside the padded area
//   const x = padding + (availableWidth - finalWidth) / 2;
//   const y = padding + (availableHeight - finalHeight) / 2;

//   pdf.addImage(imgData, "JPEG", x, y, finalWidth, finalHeight);

//   const pdfBlob = pdf.output("arraybuffer");

//   zip.file(
//     `image_${result[index].value}_${index + 1}.pdf`,
//     pdfBlob
//   );
// });


//     await Promise.all(pdfPromises);

//     // Generate ZIP
//     const content = await zip.generateAsync({ type: "blob" });
//     saveAs(content, "id_images.zip");
//   } catch (error) {
//     console.error("Error generating PDFs ZIP:", error);
//   } finally {
//     setLoader(false);
//   }
// };

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected.length > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected.length > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected.length} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Students
        </Typography>
      )}

      {numSelected.length > 0 && (
        <Tooltip title="Generate Id Card">
          <Button onClick={captureImagesAndDownload} variant="contained">Generate</Button>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function EnhancedTable({columns, rows, setLoader, idvalue}) {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);


  const rowsSelect = selected.map(ab => rows.filter(va => va.ano === ab)[0]);

    console.log("rows", rowsSelect);


  useEffect(()=>{
      setSelected([]);
  }, [rows])

  const divRefs = useRef([]);

  const addToRefs = (el) => {
    if (el && !divRefs.current.includes(el)) {
      divRefs.current.push(el);
    }
  };

  const dispatch = useDispatch();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setLoader(true);
      const newSelected = rows.map((n) => n.ano);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;


  const handleDelete = (id) => {
    setLoader(true);
    const c_id = id
    dispatch(deleteidstudent({c_id}))
    .then(() => {
      setLoader(false);
    })
    .catch(()=>{
      setLoader(false);
    })
  }

  console.log(rowsSelect);

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <EnhancedTableToolbar setLoader={setLoader} idvalue={idvalue} rowsSelect={rowsSelect} rows={rows} divRefs={divRefs} numSelected={selected} />
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              columns={columns}
            />
            <TableBody>
              {[...rows]?.sort((a, b) => a?.ano?.localeCompare(b?.ano))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const isItemSelected = isSelected(row.ano);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.ano}
                    selected={isItemSelected}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell 
                    padding="checkbox"
                    onClick={(event) => handleClick(event, row.ano)}
                    >
                      <Checkbox
                        color="primary"
                        checked={isItemSelected}
                        inputProps={{
                          'aria-labelledby': labelId,
                        }}
                      />
                    </TableCell>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <>
                        <TableCell key={column.id} align={column.align}>
                        { column.id === "img" ? <img src={row.img ? row.img : `https://static.vecteezy.com/system/resources/thumbnails/002/002/403/small/man-with-beard-avatar-character-isolated-icon-free-vector.jpg`} width={50} alt='photo'/> : column.id === "sign" ? <img src={row.sign ? row.sign : `https://static.vecteezy.com/system/resources/thumbnails/002/002/403/small/man-with-beard-avatar-character-isolated-icon-free-vector.jpg`} width={50} alt='photo'/> : value}
                            {column.id === "action" && 
                                    column.actionType.map((a)=>{
                                        return (
                                            <Box sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                    {a.edit && <Editstudent setLoader={setLoader} editData={row}/>}
                                     {a.delete && (
                                        <Button
                                          sx={{
                                            background: "#dc0707",
                                            marginRight: 2,
                                            height: '40px',
                                            width:'40px',
                                            minWidth: 0
                                          }}
                                          onClick={() => handleDelete(row._id)}
                                        >
                                          <DeleteIcon
                                            sx={{ color: "#fff", fontSize: 17 }}
                                          ></DeleteIcon>
                                        </Button>
                                    )}
                                            </Box>
                                        )
                                    })
                            }
                        </TableCell>
                        </>
                      );
                    })}
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 20, 30]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <ImageLoaderComponent idvalue={idvalue} setLoader={setLoader} rowsSelect={rowsSelect} addToRefs={addToRefs}/>
    </Box>
  );
}
